import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { MenuContentWrapper as _MenuContentWrapper } from '@wingscms/crane';
import DefaultFooter from './Footer';
var LayoutContainer = styled.main.withConfig({
  displayName: "LayoutDefault__LayoutContainer",
  componentId: "be38o7-0"
})(["background-color:", ";width:100%;position:relative;overflow:hidden;"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor;
});
var ContentContainer = styled.div.withConfig({
  displayName: "LayoutDefault__ContentContainer",
  componentId: "be38o7-1"
})(["min-height:100vh;"]);
var MenuContentWrapper = styled(_MenuContentWrapper).withConfig({
  displayName: "LayoutDefault__MenuContentWrapper",
  componentId: "be38o7-2"
})([".slide-menu.chapters{position:fixed;z-index:50;}&.chaptersOpen{.slide-menu.chapters{position:fixed;margin-left:300px;top:0;height:100vh;}}@media screen and (max-width:800px){.slide-menu.chapters{left:-100vw;}&.chaptersOpen{margin-left:100vw;padding-right:100vw;width:calc(100% + 100vw);.slide-menu.chapters{margin-left:100vw;}}}"]);

var Layout =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Layout, _Component);

  function Layout() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Layout.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        Footer = _this$props.footer;
    return React.createElement(LayoutContainer, null, React.createElement(MenuContentWrapper, {
      id: "content-wrapper"
    }, React.createElement(ContentContainer, null, children), React.createElement(Footer, null)));
  };

  return Layout;
}(Component);

Layout.defaultProps = {
  footer: DefaultFooter
};
export default withTheme(Layout);